module.exports = __webpack_public_path__ + "img/icon-right-1.46bc069e.svg";